export class MigratedClaim {
    claimNumber: number;
    claimDate: Date;
    claimDateString: string;
    situationDescription: string;
    instanceDescription: string;
    caseTitle: string;
    claimId: number;
    instanceCode: number;
    insuredName: string;
    insuredCode: number;
    lawyerName?: string; // Se asume opcional si en C# era nullable
    proceduralStageDescription?: string;
    proceduralStageCode?: number;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/migratedClaim.ts